/** Terminal generations stay dirty until their take refresh succeeds. New changes survive an older refresh. */
export function createShotRefreshQueue() {
  const dirty = new Map<string, number>();
  let revision = 0;
  return {
    mark(ids: string[]) {
      for (const id of ids) dirty.set(id, ++revision);
    },
    ids: () => [...dirty.keys()],
    async refresh(ids: string[], reconcile: () => Promise<void>) {
      const started = new Map(ids.map((id) => [id, dirty.get(id)]));
      await reconcile();
      for (const [id, rev] of started) if (dirty.get(id) === rev) dirty.delete(id);
    },
  };
}
